import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, onSnapshot, deleteDoc } from "firebase/firestore";
import { FaBell } from "react-icons/fa";
import "./NotificationBell.css";

const NotificationBellLider = () => {
  const [pausedNotification, setPausedNotification] = useState(null);
  const [pendingReviewNotification, setPendingReviewNotification] = useState(null);
  const [pendingAssignmentNotification, setPendingAssignmentNotification] = useState(null);
  const [planningNotification, setPlanningNotification] = useState(null);
  const [completedNotification, setCompletedNotification] = useState(null);
  const [open, setOpen] = useState(false);
  const [grupo, setGrupo] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const storedGrupo = localStorage.getItem("grupo");
    if (!storedGrupo) {
      console.log("No se encontró grupo en localStorage");
      return;
    }
    const normalizedGrupo = `grupo_${storedGrupo.trim()}`; // Formato: grupo_1, grupo_2, etc.
    console.log("Grupo normalizado:", normalizedGrupo);
    setGrupo(normalizedGrupo);

    // Escuchar notificaciones de actividades pausadas
    const pausedSummaryRef = doc(db, `notifications/${normalizedGrupo}/summary/status`);
    console.log("Escuchando notificaciones pausadas en:", `notifications/${normalizedGrupo}/summary/status`);
    const unsubPaused = onSnapshot(
      pausedSummaryRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = { id: docSnapshot.id, ...docSnapshot.data() };
          console.log("Notificación de pausas recibida para líder:", data);
          setPausedNotification(data);
        } else {
          console.log("No hay notificación de pausas activa para el grupo");
          setPausedNotification(null);
        }
      },
      (error) => {
        console.error("Error al escuchar notificación de pausas:", error);
      }
    );

    // Escuchar notificaciones de actividades pendientes de revisión
    const pendingReviewSummaryRef = doc(db, `notifications/${normalizedGrupo}/pending_reviews/status`);
    console.log("Escuchando notificaciones de revisiones en:", `notifications/${normalizedGrupo}/pending_reviews/status`);
    const unsubPendingReview = onSnapshot(
      pendingReviewSummaryRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = { id: docSnapshot.id, ...docSnapshot.data() };
          console.log("Notificación de revisiones recibida para líder:", data);
          setPendingReviewNotification(data);
        } else {
          console.log("No hay notificación de revisiones activa para el grupo");
          setPendingReviewNotification(null);
        }
      },
      (error) => {
        console.error("Error al escuchar notificación de revisiones:", error);
      }
    );

    // Escuchar notificaciones de actividades pendientes de asignación
    const pendingAssignmentSummaryRef = doc(db, `notifications/${normalizedGrupo}/pending_assignments/status`);
    console.log("Escuchando notificaciones de asignaciones en:", `notifications/${normalizedGrupo}/pending_assignments/status`);
    const unsubPendingAssignment = onSnapshot(
      pendingAssignmentSummaryRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = { id: docSnapshot.id, ...docSnapshot.data() };
          console.log("Notificación de asignaciones recibida para líder:", data);
          setPendingAssignmentNotification(data);
        } else {
          console.log("No hay notificación de asignaciones activa para el grupo");
          setPendingAssignmentNotification(null);
        }
      },
      (error) => {
        console.error("Error al escuchar notificación de asignaciones:", error);
      }
    );

    // Escuchar notificaciones de actividades para planificar
    const planningSummaryRef = doc(db, `notifications/${normalizedGrupo}/planning/status`);
    console.log("Escuchando notificaciones de planificación en:", `notifications/${normalizedGrupo}/planning/status`);
    const unsubPlanning = onSnapshot(
      planningSummaryRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = { id: docSnapshot.id, ...docSnapshot.data() };
          console.log("Notificación de planificación recibida para líder:", data);
          setPlanningNotification(data);
        } else {
          console.log("No hay notificación de planificación activa para el grupo");
          setPlanningNotification(null);
        }
      },
      (error) => {
        console.error("Error al escuchar notificación de planificación:", error);
      }
    );

    // Escuchar notificaciones de actividades completadas
    const completedSummaryRef = doc(db, `notifications/${normalizedGrupo}/completed/status`);
    console.log("Escuchando notificaciones de actividades completadas en:", `notifications/${normalizedGrupo}/completed/status`);
    const unsubCompleted = onSnapshot(
      completedSummaryRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = { id: docSnapshot.id, ...docSnapshot.data() };
          console.log("Notificación de actividades completadas recibida para líder:", data);
          setCompletedNotification(data);
        } else {
          console.log("No hay notificación de actividades completadas activa para el grupo");
          setCompletedNotification(null);
        }
      },
      (error) => {
        console.error("Error al escuchar notificación de actividades completadas:", error);
      }
    );

    return () => {
      unsubPaused();
      unsubPendingReview();
      unsubPendingAssignment();
      unsubPlanning();
      unsubCompleted();
    };
  }, []);

  const handleGoToPaused = () => {
    navigate("/PausaLider");
    setOpen(false);
  };

  const handleGoToPendingReviews = () => {
    navigate("/RevisarActividadLider");
    setOpen(false);
  };

  const handleGoToPendingAssignments = () => {
    navigate("/AsignarStaff"); 
    setOpen(false);
  };

  const handleViewPlanning = async () => {
    if (grupo) {
      try {
        const planningRef = doc(db, `notifications/${grupo}/planning/status`);
        await deleteDoc(planningRef);
        console.log("Notificación de planificación eliminada para grupo:", grupo);
        setPlanningNotification(null); // Actualizar el estado localmente
      } catch (error) {
        console.error("Error al eliminar notificación de planificación:", error);
      }
    }
    navigate("/ActividadesSinDocumentar");
    setOpen(false);
  };

  const handleViewCompleted = async () => {
    if (grupo) {
      try {
        const completedRef = doc(db, `notifications/${grupo}/completed/status`);
        await deleteDoc(completedRef);
        console.log("Notificación de actividades completadas eliminada para grupo:", grupo);
        setCompletedNotification(null); // Actualizar el estado localmente
      } catch (error) {
        console.error("Error al eliminar notificación de actividades completadas:", error);
      }
    }
    navigate("/SolicitudesCompletadasLider");
    setOpen(false);
  };

  if (!grupo) {
    return <div className="text-sm text-gray-600">Por favor, inicia sesión para ver notificaciones.</div>;
  }

  // Sumar los conteos de todas las notificaciones para el ícono de la campana
  const totalCount = (pausedNotification?.count || 0) + (pendingReviewNotification?.count || 0) + (pendingAssignmentNotification?.count || 0) + (planningNotification?.count || 0) + (completedNotification?.count || 0);
  console.log("Total conteo de notificaciones:", totalCount, { pausedNotification, pendingReviewNotification, pendingAssignmentNotification, planningNotification, completedNotification });

  return (
    <div className="notification-bell-container">
      <div
        className="bell-icon"
        onClick={() => setOpen((prev) => !prev)}
      >
        <FaBell size={24} />
        {totalCount > 0 && (
          <span className="notification-count">{totalCount}</span>
        )}
      </div>

      {open && (
        <div className="notification-dropdown">
          {pausedNotification || pendingReviewNotification || pendingAssignmentNotification || planningNotification || completedNotification ? (
            <>
              {pausedNotification && (
                <div className="notification-item">
                  <p>{pausedNotification.message}</p>
                  <button onClick={handleGoToPaused}>Ir</button>
                </div>
              )}
              {pendingReviewNotification && (
                <div className="notification-item">
                  <p>{pendingReviewNotification.message}</p>
                  <button onClick={handleGoToPendingReviews}>Ir</button>
                </div>
              )}
              {pendingAssignmentNotification && (
                <div className="notification-item">
                  <p>{pendingAssignmentNotification.message}</p>
                  <button onClick={handleGoToPendingAssignments}>Ir</button>
                </div>
              )}
              {planningNotification && (
                <div className="notification-item">
                  <p>{planningNotification.message}</p>
                  <button onClick={handleViewPlanning}>Ver</button>
                </div>
              )}
              {completedNotification && (
                <div className="notification-item">
                  <p>{completedNotification.message}</p>
                  <button onClick={handleViewCompleted}>Ver</button>
                </div>
              )}
            </>
          ) : (
            <p className="text-sm text-gray-600 p-4 text-center">
              No hay nuevas notificaciones
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBellLider;